import React from "react";
import { useNavigate } from "react-router-dom";

const BlogDetail = () => {
  const navigate = useNavigate();

  return (
    <>
      {/* Page Title */}
      <div className="main_title">
        <h1>Blog Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> –{" "}
          <button onClick={() => navigate("/manage-blogs-listings")}>Blog Listings</button>{" "}
          – Blog Detail
        </p>
      </div>

      {/* General Information */}
      <div className="cards view_page mb_20">
        <div className="table_header mb_20">
          <h2>General Information</h2>
          <span className="status_btn dark c_success">Active</span>
        </div>

        <div className="gap_p">
          {/* Blog Image */}
          <div className="vew_img v2 w_100">
            <h6>Blog Image</h6>
            <figure className="no_radius">
              <img alt="blog" src="/static/images/placeholder.png" />
            </figure>
          </div>

          {/* Blog Title */}
          <div className="w_33">
            <h6>Blog Title</h6>
            <p>How to Improve Your UI Design</p>
          </div>

          {/* Blog Category */}
          <div className="w_33">
            <h6>Blog Category</h6>
            <p>Tips & Tricks for Buying Used Cars</p>
          </div>

          {/* Created Date */}
          <div className="w_33">
            <h6>Created Date</h6>
            <p>01 March 2025</p>
          </div>

          {/* Full Width Description */}
          <div className="w_100">
            <h6>Blog Description</h6>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia officia deleniti quos quo sed perspiciatis vero eum nobis, alias esse cumque tempora, amet quam deserunt fuga autem dignissimos. Nemo, accusantium dolore. Deserunt doloremque veniam quia maiores alias nostrum obcaecati vitae dolores magni, consequatur quam sit. Delectus cum ea quae incidunt officiis modi perspiciatis illo eligendi exercitationem aliquam a, eveniet consequuntur eum aperiam nihil autem. Aspernatur illum neque, tenetur totam iure odit quo velit obcaecati! Voluptatum quam cumque beatae repellendus qui, et harum repellat explicabo laborum animi assumenda modi expedita placeat nemo ex soluta dolores rerum quod laboriosam fugit reiciendis aliquid? </p>
          </div>
        </div>
      </div>

      {/* Author Detail */}
      <div className="cards view_page">
        <div className="table_header mb_20">
          <h2>Author Detail</h2>
        </div>

        <div className="gap_p">
          {/* Author Image */}
          <div className="vew_img w_33">
            <h6>Author Image</h6>
            <figure>
              <img alt="author" src="/static/images/placeholder.png" />
            </figure>
          </div>

          {/* Author Name */}
          <div className="w_33">
            <h6>Author Name</h6>
            <p>John Doe</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetail;
